<style lang="scss" scoped>
@import "core";

.my__first-subject {
  margin-bottom: 20px;
  margin-top: 20px;

  @include mq(pc) {
    border: solid 1px $color-divider;
    padding: 19px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  @include mq(sp) {
    display: flex;
    flex-direction: column;
  }

  &__select {
    @include mq(pc) {
      min-width: 190px;
    }

    @include mq(sp) {
      width: 100%;
      order: 2;
      margin-top: 5px;
    }
  }

  &__guide {
    @include mq(pc) {
      margin-left: 20px;
    }

    @include mq(sp) {
      // margin-top: 5px;
      order: 1;
    }
  }
}

.my__subjects {
  border: solid 1px $color-divider;
}

.my__subject {
  &:not(:first-child) {
    border-top: solid 1px $color-divider;
  }
}

.my__judgement-notes {
  font-size: 90%;
  margin-bottom: 10px;
}
</style>



<template>
  <div class="my" :id="`category-${id}`">
    <div class="my__anchor-point" v-for="subject in subjects" :key="subject.id" :id="`a${subject.id}`"></div>
    <h2 class="my__name mdTtl02">{{name}}</h2>
    <p v-if="id === '4'" class="my__judgement-notes">英語以外の外国語に得点を入力した場合は、「英語（リスニング）」の得点は入力できません。「英語（リスニング）テスト受験免除者」は、「英語（リーディング）」と同じ点数を「英語（リスニング）」に入力してください。</p>
    <p v-if="id === '8'" class="my__judgement-notes">「簿記・会計」「情報関係基礎」に得点を入力した場合は「数IIＢ」として自動的に集計し、合格可能性を判定します。</p>
    <div v-if="subjects.length" class="my__subjects" :id="`subjects-${id}`">
      <my-subject
        class="my__subject"
        v-for="subject in subjects"
        :key="subject.id"
        :id="subject.id"
        ref="subjects"
        @change-state="onChangeSubjectState(subject, $event)"
      />
    </div>

    <div v-if="firstChoiceSelectable" class="my__first-subject">
      <select
        class="my__first-subject__select"
        v-model="firstChoice"
      >
        <option :value="null">{{name}}受験なし</option>
        <option
          v-for="subject in firstChoiceSubjects"
          :key="subject.id"
          :value="subject.id"
          v-if="subject.fixed"
        >{{subject.name}}</option>
      </select>
      <div class="my__first-subject__guide">
        {{name}}の第1解答科目を選択してください。
      </div>
    </div>
  </div>
</template>



<script>
import MySubject from './Subject';



export default {
  components: {
    MySubject,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  inject: ['resetCaliculateState'],

  computed: {
    data() { return this.$store.getters['selfcheck/groupedCategoryById'](this.id) },
    name() { return this.data.name },
    subjects() { return this.data.subjects },
    firstChoiceSelectable() { return this.data.firstChoiceSelectable },
    firstChoice: {
      get() { return this.$store.getters['selfcheck/groupedCategoryFirstChoice'](this.id) },
      async set(val) {
        await this.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', {categoryId: this.id, subjectId: val});
        this.resetCaliculateState && this.resetCaliculateState();
      },
    },
    firstChoiceSubjects() {
      return this.subjects.map(subject => {
        const history = this.$store.getters['selfcheck/subjectHistory'](subject.id);
        return {
          id   : subject.id,
          name : subject.name,
          fixed: history.state === 'fixed',
        }
      });
    },
  },

  methods: {
    onChangeSubjectState(subject, state) {
      if (state !== 'fixed' && this.firstChoice === subject.id) {
        this.firstChoice = null;
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// Category.vue?dea916e2